export const STYLING_CARD_PREVIEW_BACKGROUND = {
    default: 'transparent',
    inverse: 'var(--uilab-sys-color-inverse-background-20)',
} as const;
